import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Dylan Oli
 * id D52803B6-8580-4C06-AA9F-96B4748286DB
 * name store-minus
 * version: 5.7.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/store-minus.svg
 * tags
 * - Places 
 * - Shopping 
 */
export const StoreMinusIcon = createSvgIcon(<><path d="M4 4V6H20V4M4 7L3 12V14H4V20H13C12.95 19.66 12.92 19.31 12.92 18.95C12.92 17.73 13.3 16.53 14 15.53V14H15.54C16.54 13.33 17.71 12.96 18.91 12.96C19.62 12.96 20.33 13.09 21 13.34V12L20 7M6 14H12V18H6M15 18V20H23V18" /></>, 'StoreMinusIcon');
export default StoreMinusIcon